import React, { useState, useEffect } from "react";
import { Menu, X, Sun, Moon } from "lucide-react";
import logo from './assets/img/AngoNet.png';
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import QuoteModal from './ModalOrcamento';





export default function Header({ isDarkMode, setIsDarkMode }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const navigate = useNavigate();
    const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);
const [preSelectedService, setPreSelectedService] = useState(null);
    

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
 
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? isDarkMode 
            ? 'bg-gray-900/90 backdrop-blur-xl border-b border-white/10 shadow-lg' 
            : 'bg-white/90 backdrop-blur-xl border-b border-gray-200 shadow-lg'
          : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
<div className="flex items-center space-x-2">
  <Link to="/">
    <img 
      src={logo} 
      alt="AngoNet Logo"
      className="h-20 md:h-22 object-contain cursor-pointer transition-transform hover:scale-105"
    />
  </Link>
</div>

            
            <div className="hidden md:flex items-center space-x-8">
              <a href="/" className={`font-medium transition-colors ${
                isDarkMode ? 'text-gray-300 hover:text-cyan-400' : 'text-gray-700 hover:text-blue-600'
              }`}>Início</a>
              <a href="/servicos" className={`font-medium transition-colors ${
                isDarkMode ? 'text-gray-300 hover:text-cyan-400' : 'text-gray-700 hover:text-blue-600'
              }`}>Serviços</a>
              <a href="/sobre" className={`font-medium transition-colors ${
                isDarkMode ? 'text-gray-300 hover:text-cyan-400' : 'text-gray-700 hover:text-blue-600'
              }`}>Sobre</a>
                <a href="/projectos" className={`font-medium transition-colors ${
                isDarkMode ? 'text-gray-300 hover:text-cyan-400' : 'text-gray-700 hover:text-blue-600'
              }`}>Projectos</a>
                <a href="/blog" className={`font-medium transition-colors ${
                isDarkMode ? 'text-gray-300 hover:text-cyan-400' : 'text-gray-700 hover:text-blue-600'
              }`}>Blog</a>
               <a href="/faq" className={`font-medium transition-colors ${
                isDarkMode ? 'text-gray-300 hover:text-cyan-400' : 'text-gray-700 hover:text-blue-600'
              }`}>FAQ</a>
              <a href="/contacto" className={`font-medium transition-colors ${
                isDarkMode ? 'text-gray-300 hover:text-cyan-400' : 'text-gray-700 hover:text-blue-600'
              }`}>Contacto</a>
              
              {/* Dark Mode Toggle
              <button
                onClick={() => setIsDarkMode(!isDarkMode)}
                className={`p-2 rounded-full transition-all ${
                  isDarkMode 
                    ? 'bg-yellow-500/20 text-yellow-400 hover:bg-yellow-500/30' 
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
                aria-label="Toggle dark mode"
              >
                {isDarkMode ? <Sun size={20} /> : <Moon size={20} />}
              </button> */}

              <button className="px-6 py-2.5 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-full hover:shadow-xl hover:shadow-blue-500/40 transition-all font-medium"
                onClick={() => setIsQuoteModalOpen(true)}
              >
                Solicitar Orçamento
              </button>
            </div>

            <button 
              className={isDarkMode ? 'md:hidden text-white' : 'md:hidden text-gray-900'}
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className={`md:hidden backdrop-blur-xl border-t shadow-lg ${
            isDarkMode ? 'bg-gray-900/95 border-white/10' : 'bg-white/95 border-gray-200'
          }`}>
            <div className="px-6 py-4 space-y-4">
              <a href="#home" className={`block font-medium ${
                isDarkMode ? 'text-gray-300 hover:text-cyan-400' : 'text-gray-700 hover:text-blue-600'
              }`}>Início</a>
              <a href="#services" className={`block font-medium ${
                isDarkMode ? 'text-gray-300 hover:text-cyan-400' : 'text-gray-700 hover:text-blue-600'
              }`}>Serviços</a>
              <a href="#about" className={`block font-medium ${
                isDarkMode ? 'text-gray-300 hover:text-cyan-400' : 'text-gray-700 hover:text-blue-600'
              }`}>Sobre</a>
              <a href="#contact" className={`block font-medium ${
                isDarkMode ? 'text-gray-300 hover:text-cyan-400' : 'text-gray-700 hover:text-blue-600'
              }`}>Contacto</a>
              
              {/*
              <button
                onClick={() => setIsDarkMode(!isDarkMode)}
                className={`flex items-center space-x-2 p-2 rounded-lg transition-all ${
                  isDarkMode 
                    ? 'bg-yellow-500/20 text-yellow-400' 
                    : 'bg-gray-200 text-gray-700'
                }`}
              >
                {isDarkMode ? <Sun size={20} /> : <Moon size={20} />}
                <span>{isDarkMode ? 'Modo Claro' : 'Modo Escuro'}</span>
              </button>
              */}

              <button  className="w-full px-6 py-2.5 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-full font-medium"
              onClick={() => setIsQuoteModalOpen(true)}
              >
                
                Solicitar Orçamento
              </button>
            </div>
          </div>
        )}

        <QuoteModal
  isOpen={isQuoteModalOpen}
  onClose={() => setIsQuoteModalOpen(false)}
  isDarkMode={isDarkMode}
  preSelectedService={preSelectedService}  
/>
      </nav>

  );
}
